// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/assessment_report_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/assessment_report_service.proto.
 */
export const file_inventory_v1_assessment_report_service: GenFile = /*@__PURE__*/
  fileDesc("CixpbnZlbnRvcnkvdjEvYXNzZXNzbWVudF9yZXBvcnRfc2VydmljZS5wcm90bxIMaW52ZW50b3J5LnYxIpYCChhBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGUSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIYCgtkZXNjcmlwdGlvbhgDIAEoCUgAiAEBEhUKDWdsb2JhbF9wcm9tcHQYBCABKAkSPwoIc2VjdGlvbnMYBSADKAsyLS5pbnZlbnRvcnkudjEuQXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlU2VjdGlvbhIuCgpjcmVhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIOCgxfZGVzY3JpcHRpb24iuwEKH0Fzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVNlY3Rpb24SCgoCaWQYASABKAkSDQoFdGl0bGUYAiABKAkSDgoGcHJvbXB0GAMgASgJEg0KBWluZGV4GAQgASgFEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIjYKFUdlbmVyYXRlUmVwb3J0UmVxdWVzdBIdChVvbmdvaW5nX2Fzc2Vzc21lbnRfaWQYASABKAkiSAoWR2VuZXJhdGVSZXBvcnRSZXNwb25zZRIuCgZyZXBvcnQYASABKAsyHi5pbnZlbnRvcnkudjEuQXNzZXNzbWVudFJlcG9ydCLdAQoQQXNzZXNzbWVudFJlcG9ydBIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEg8KB2NvbnRlbnQYAyABKAwSLgoKY3JlYXRlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASIwoWbGFzdF9lZGl0ZWRfYnlfdXNlcl9pZBgGIAEoCUgAiAEBQhkKF19sYXN0X2VkaXRlZF9ieV91c2VyX2lkIj0KHExpc3RBc3Nlc3NtZW50UmVwb3J0c1JlcXVlc3QSHQoVb25nb2luZ19hc3Nlc3NtZW50X2lkGAEgASgJIlAKHUxpc3RBc3Nlc3NtZW50UmVwb3J0c1Jlc3BvbnNlEi8KB3JlcG9ydHMYASADKAsyHi5pbnZlbnRvcnkudjEuQXNzZXNzbWVudFJlcG9ydCJwCh1VcGRhdGVBc3Nlc3NtZW50UmVwb3J0UmVxdWVzdBIRCglyZXBvcnRfaWQYASABKAkSEQoEbmFtZRgCIAEoCUgAiAEBEhQKB2NvbnRlbnQYAyABKAxIAYgBAUIHCgVfbmFtZUIKCghfY29udGVudCIgCh5VcGRhdGVBc3Nlc3NtZW50UmVwb3J0UmVzcG9uc2UiMgodRGVsZXRlQXNzZXNzbWVudFJlcG9ydFJlcXVlc3QSEQoJcmVwb3J0X2lkGAEgASgJIiAKHkRlbGV0ZUFzc2Vzc21lbnRSZXBvcnRSZXNwb25zZSIlCiNHZXRBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVzUmVxdWVzdCJgCiRHZXRBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVzUmVzcG9uc2USOAoIdGVtcGxhdGUYASABKAsyJi5pbnZlbnRvcnkudjEuQXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlInwKIlNldEFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVJlcXVlc3QSFQoNZ2xvYmFsX3Byb21wdBgBIAEoCRI/CghzZWN0aW9ucxgCIAMoCzItLmludmVudG9yeS52MS5Bc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVTZWN0aW9uImcKJ0Fzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVNlY3Rpb25SZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIEhIKBWVycm9yGAIgASgJSACIAQESCgoCaWQYAyABKAlCCAoGX2Vycm9yItMBCiNTZXRBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVSZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIElAKEXNlY3Rpb25fcmVzcG9uc2VzGAIgAygLMjUuaW52ZW50b3J5LnYxLkFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVNlY3Rpb25SZXNwb25zZRInChpnZW5lcmFsX2luc3RydWN0aW9uc19lcnJvchgDIAEoCUgAiAEBQh0KG19nZW5lcmFsX2luc3RydWN0aW9uc19lcnJvciKwAQolVXBkYXRlQXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlUmVxdWVzdBITCgt0ZW1wbGF0ZV9pZBgBIAEoCRIRCgRuYW1lGAIgASgJSACIAQESGAoLZGVzY3JpcHRpb24YAyABKAlIAYgBARIaCg1nbG9iYWxfcHJvbXB0GAQgASgJSAKIAQFCBwoFX25hbWVCDgoMX2Rlc2NyaXB0aW9uQhAKDl9nbG9iYWxfcHJvbXB0IigKJlVwZGF0ZUFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVJlc3BvbnNlIi8KLVJlc2V0QXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlVG9EZWZhdWx0UmVxdWVzdCIwCi5SZXNldEFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVRvRGVmYXVsdFJlc3BvbnNlMp0IChdBc3Nlc3NtZW50UmVwb3J0U2VydmljZRJbCg5HZW5lcmF0ZVJlcG9ydBIjLmludmVudG9yeS52MS5HZW5lcmF0ZVJlcG9ydFJlcXVlc3QaJC5pbnZlbnRvcnkudjEuR2VuZXJhdGVSZXBvcnRSZXNwb25zZRKKAQocR2V0QXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlcxIxLmludmVudG9yeS52MS5HZXRBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVzUmVxdWVzdBoyLmludmVudG9yeS52MS5HZXRBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVzUmVzcG9uc2UiA5ACARKCAQobU2V0QXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlEjAuaW52ZW50b3J5LnYxLlNldEFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVJlcXVlc3QaMS5pbnZlbnRvcnkudjEuU2V0QXNzZXNzbWVudFJlcG9ydFRlbXBsYXRlUmVzcG9uc2USiwEKHlVwZGF0ZUFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZRIzLmludmVudG9yeS52MS5VcGRhdGVBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVSZXF1ZXN0GjQuaW52ZW50b3J5LnYxLlVwZGF0ZUFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVJlc3BvbnNlEqMBCiZSZXNldEFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVRvRGVmYXVsdBI7LmludmVudG9yeS52MS5SZXNldEFzc2Vzc21lbnRSZXBvcnRUZW1wbGF0ZVRvRGVmYXVsdFJlcXVlc3QaPC5pbnZlbnRvcnkudjEuUmVzZXRBc3Nlc3NtZW50UmVwb3J0VGVtcGxhdGVUb0RlZmF1bHRSZXNwb25zZRJzChZVcGRhdGVBc3Nlc3NtZW50UmVwb3J0EisuaW52ZW50b3J5LnYxLlVwZGF0ZUFzc2Vzc21lbnRSZXBvcnRSZXF1ZXN0GiwuaW52ZW50b3J5LnYxLlVwZGF0ZUFzc2Vzc21lbnRSZXBvcnRSZXNwb25zZRJzChZEZWxldGVBc3Nlc3NtZW50UmVwb3J0EisuaW52ZW50b3J5LnYxLkRlbGV0ZUFzc2Vzc21lbnRSZXBvcnRSZXF1ZXN0GiwuaW52ZW50b3J5LnYxLkRlbGV0ZUFzc2Vzc21lbnRSZXBvcnRSZXNwb25zZRJ1ChVMaXN0QXNzZXNzbWVudFJlcG9ydHMSKi5pbnZlbnRvcnkudjEuTGlzdEFzc2Vzc21lbnRSZXBvcnRzUmVxdWVzdBorLmludmVudG9yeS52MS5MaXN0QXNzZXNzbWVudFJlcG9ydHNSZXNwb25zZSIDkAIBQsQBChBjb20uaW52ZW50b3J5LnYxQhxBc3Nlc3NtZW50UmVwb3J0U2VydmljZVByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message inventory.v1.AssessmentReportTemplate
 */
export type AssessmentReportTemplate = Message<"inventory.v1.AssessmentReportTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string global_prompt = 4;
   */
  globalPrompt: string;

  /**
   * @generated from field: repeated inventory.v1.AssessmentReportTemplateSection sections = 5;
   */
  sections: AssessmentReportTemplateSection[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.AssessmentReportTemplate.
 * Use `create(AssessmentReportTemplateSchema)` to create a new message.
 */
export const AssessmentReportTemplateSchema: GenMessage<AssessmentReportTemplate> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 0);

/**
 * @generated from message inventory.v1.AssessmentReportTemplateSection
 */
export type AssessmentReportTemplateSection = Message<"inventory.v1.AssessmentReportTemplateSection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string prompt = 3;
   */
  prompt: string;

  /**
   * @generated from field: int32 index = 4;
   */
  index: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.AssessmentReportTemplateSection.
 * Use `create(AssessmentReportTemplateSectionSchema)` to create a new message.
 */
export const AssessmentReportTemplateSectionSchema: GenMessage<AssessmentReportTemplateSection> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 1);

/**
 * @generated from message inventory.v1.GenerateReportRequest
 */
export type GenerateReportRequest = Message<"inventory.v1.GenerateReportRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.GenerateReportRequest.
 * Use `create(GenerateReportRequestSchema)` to create a new message.
 */
export const GenerateReportRequestSchema: GenMessage<GenerateReportRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 2);

/**
 * @generated from message inventory.v1.GenerateReportResponse
 */
export type GenerateReportResponse = Message<"inventory.v1.GenerateReportResponse"> & {
  /**
   * @generated from field: inventory.v1.AssessmentReport report = 1;
   */
  report?: AssessmentReport;
};

/**
 * Describes the message inventory.v1.GenerateReportResponse.
 * Use `create(GenerateReportResponseSchema)` to create a new message.
 */
export const GenerateReportResponseSchema: GenMessage<GenerateReportResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 3);

/**
 * @generated from message inventory.v1.AssessmentReport
 */
export type AssessmentReport = Message<"inventory.v1.AssessmentReport"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bytes content = 3;
   */
  content: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string last_edited_by_user_id = 6;
   */
  lastEditedByUserId?: string;
};

/**
 * Describes the message inventory.v1.AssessmentReport.
 * Use `create(AssessmentReportSchema)` to create a new message.
 */
export const AssessmentReportSchema: GenMessage<AssessmentReport> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 4);

/**
 * @generated from message inventory.v1.ListAssessmentReportsRequest
 */
export type ListAssessmentReportsRequest = Message<"inventory.v1.ListAssessmentReportsRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.ListAssessmentReportsRequest.
 * Use `create(ListAssessmentReportsRequestSchema)` to create a new message.
 */
export const ListAssessmentReportsRequestSchema: GenMessage<ListAssessmentReportsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 5);

/**
 * @generated from message inventory.v1.ListAssessmentReportsResponse
 */
export type ListAssessmentReportsResponse = Message<"inventory.v1.ListAssessmentReportsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentReport reports = 1;
   */
  reports: AssessmentReport[];
};

/**
 * Describes the message inventory.v1.ListAssessmentReportsResponse.
 * Use `create(ListAssessmentReportsResponseSchema)` to create a new message.
 */
export const ListAssessmentReportsResponseSchema: GenMessage<ListAssessmentReportsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 6);

/**
 * @generated from message inventory.v1.UpdateAssessmentReportRequest
 */
export type UpdateAssessmentReportRequest = Message<"inventory.v1.UpdateAssessmentReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional bytes content = 3;
   */
  content?: Uint8Array;
};

/**
 * Describes the message inventory.v1.UpdateAssessmentReportRequest.
 * Use `create(UpdateAssessmentReportRequestSchema)` to create a new message.
 */
export const UpdateAssessmentReportRequestSchema: GenMessage<UpdateAssessmentReportRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 7);

/**
 * @generated from message inventory.v1.UpdateAssessmentReportResponse
 */
export type UpdateAssessmentReportResponse = Message<"inventory.v1.UpdateAssessmentReportResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateAssessmentReportResponse.
 * Use `create(UpdateAssessmentReportResponseSchema)` to create a new message.
 */
export const UpdateAssessmentReportResponseSchema: GenMessage<UpdateAssessmentReportResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 8);

/**
 * @generated from message inventory.v1.DeleteAssessmentReportRequest
 */
export type DeleteAssessmentReportRequest = Message<"inventory.v1.DeleteAssessmentReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;
};

/**
 * Describes the message inventory.v1.DeleteAssessmentReportRequest.
 * Use `create(DeleteAssessmentReportRequestSchema)` to create a new message.
 */
export const DeleteAssessmentReportRequestSchema: GenMessage<DeleteAssessmentReportRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 9);

/**
 * @generated from message inventory.v1.DeleteAssessmentReportResponse
 */
export type DeleteAssessmentReportResponse = Message<"inventory.v1.DeleteAssessmentReportResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteAssessmentReportResponse.
 * Use `create(DeleteAssessmentReportResponseSchema)` to create a new message.
 */
export const DeleteAssessmentReportResponseSchema: GenMessage<DeleteAssessmentReportResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 10);

/**
 * @generated from message inventory.v1.GetAssessmentReportTemplatesRequest
 */
export type GetAssessmentReportTemplatesRequest = Message<"inventory.v1.GetAssessmentReportTemplatesRequest"> & {
};

/**
 * Describes the message inventory.v1.GetAssessmentReportTemplatesRequest.
 * Use `create(GetAssessmentReportTemplatesRequestSchema)` to create a new message.
 */
export const GetAssessmentReportTemplatesRequestSchema: GenMessage<GetAssessmentReportTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 11);

/**
 * @generated from message inventory.v1.GetAssessmentReportTemplatesResponse
 */
export type GetAssessmentReportTemplatesResponse = Message<"inventory.v1.GetAssessmentReportTemplatesResponse"> & {
  /**
   * @generated from field: inventory.v1.AssessmentReportTemplate template = 1;
   */
  template?: AssessmentReportTemplate;
};

/**
 * Describes the message inventory.v1.GetAssessmentReportTemplatesResponse.
 * Use `create(GetAssessmentReportTemplatesResponseSchema)` to create a new message.
 */
export const GetAssessmentReportTemplatesResponseSchema: GenMessage<GetAssessmentReportTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 12);

/**
 * @generated from message inventory.v1.SetAssessmentReportTemplateRequest
 */
export type SetAssessmentReportTemplateRequest = Message<"inventory.v1.SetAssessmentReportTemplateRequest"> & {
  /**
   * @generated from field: string global_prompt = 1;
   */
  globalPrompt: string;

  /**
   * @generated from field: repeated inventory.v1.AssessmentReportTemplateSection sections = 2;
   */
  sections: AssessmentReportTemplateSection[];
};

/**
 * Describes the message inventory.v1.SetAssessmentReportTemplateRequest.
 * Use `create(SetAssessmentReportTemplateRequestSchema)` to create a new message.
 */
export const SetAssessmentReportTemplateRequestSchema: GenMessage<SetAssessmentReportTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 13);

/**
 * @generated from message inventory.v1.AssessmentReportTemplateSectionResponse
 */
export type AssessmentReportTemplateSectionResponse = Message<"inventory.v1.AssessmentReportTemplateSectionResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: optional string error = 2;
   */
  error?: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.AssessmentReportTemplateSectionResponse.
 * Use `create(AssessmentReportTemplateSectionResponseSchema)` to create a new message.
 */
export const AssessmentReportTemplateSectionResponseSchema: GenMessage<AssessmentReportTemplateSectionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 14);

/**
 * @generated from message inventory.v1.SetAssessmentReportTemplateResponse
 */
export type SetAssessmentReportTemplateResponse = Message<"inventory.v1.SetAssessmentReportTemplateResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: repeated inventory.v1.AssessmentReportTemplateSectionResponse section_responses = 2;
   */
  sectionResponses: AssessmentReportTemplateSectionResponse[];

  /**
   * @generated from field: optional string general_instructions_error = 3;
   */
  generalInstructionsError?: string;
};

/**
 * Describes the message inventory.v1.SetAssessmentReportTemplateResponse.
 * Use `create(SetAssessmentReportTemplateResponseSchema)` to create a new message.
 */
export const SetAssessmentReportTemplateResponseSchema: GenMessage<SetAssessmentReportTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 15);

/**
 * @generated from message inventory.v1.UpdateAssessmentReportTemplateRequest
 */
export type UpdateAssessmentReportTemplateRequest = Message<"inventory.v1.UpdateAssessmentReportTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string global_prompt = 4;
   */
  globalPrompt?: string;
};

/**
 * Describes the message inventory.v1.UpdateAssessmentReportTemplateRequest.
 * Use `create(UpdateAssessmentReportTemplateRequestSchema)` to create a new message.
 */
export const UpdateAssessmentReportTemplateRequestSchema: GenMessage<UpdateAssessmentReportTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 16);

/**
 * @generated from message inventory.v1.UpdateAssessmentReportTemplateResponse
 */
export type UpdateAssessmentReportTemplateResponse = Message<"inventory.v1.UpdateAssessmentReportTemplateResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateAssessmentReportTemplateResponse.
 * Use `create(UpdateAssessmentReportTemplateResponseSchema)` to create a new message.
 */
export const UpdateAssessmentReportTemplateResponseSchema: GenMessage<UpdateAssessmentReportTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 17);

/**
 * @generated from message inventory.v1.ResetAssessmentReportTemplateToDefaultRequest
 */
export type ResetAssessmentReportTemplateToDefaultRequest = Message<"inventory.v1.ResetAssessmentReportTemplateToDefaultRequest"> & {
};

/**
 * Describes the message inventory.v1.ResetAssessmentReportTemplateToDefaultRequest.
 * Use `create(ResetAssessmentReportTemplateToDefaultRequestSchema)` to create a new message.
 */
export const ResetAssessmentReportTemplateToDefaultRequestSchema: GenMessage<ResetAssessmentReportTemplateToDefaultRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 18);

/**
 * @generated from message inventory.v1.ResetAssessmentReportTemplateToDefaultResponse
 */
export type ResetAssessmentReportTemplateToDefaultResponse = Message<"inventory.v1.ResetAssessmentReportTemplateToDefaultResponse"> & {
};

/**
 * Describes the message inventory.v1.ResetAssessmentReportTemplateToDefaultResponse.
 * Use `create(ResetAssessmentReportTemplateToDefaultResponseSchema)` to create a new message.
 */
export const ResetAssessmentReportTemplateToDefaultResponseSchema: GenMessage<ResetAssessmentReportTemplateToDefaultResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_report_service, 19);

/**
 * @generated from service inventory.v1.AssessmentReportService
 */
export const AssessmentReportService: GenService<{
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.GenerateReport
   */
  generateReport: {
    methodKind: "unary";
    input: typeof GenerateReportRequestSchema;
    output: typeof GenerateReportResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.GetAssessmentReportTemplates
   */
  getAssessmentReportTemplates: {
    methodKind: "unary";
    input: typeof GetAssessmentReportTemplatesRequestSchema;
    output: typeof GetAssessmentReportTemplatesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.SetAssessmentReportTemplate
   */
  setAssessmentReportTemplate: {
    methodKind: "unary";
    input: typeof SetAssessmentReportTemplateRequestSchema;
    output: typeof SetAssessmentReportTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.UpdateAssessmentReportTemplate
   */
  updateAssessmentReportTemplate: {
    methodKind: "unary";
    input: typeof UpdateAssessmentReportTemplateRequestSchema;
    output: typeof UpdateAssessmentReportTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.ResetAssessmentReportTemplateToDefault
   */
  resetAssessmentReportTemplateToDefault: {
    methodKind: "unary";
    input: typeof ResetAssessmentReportTemplateToDefaultRequestSchema;
    output: typeof ResetAssessmentReportTemplateToDefaultResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.UpdateAssessmentReport
   */
  updateAssessmentReport: {
    methodKind: "unary";
    input: typeof UpdateAssessmentReportRequestSchema;
    output: typeof UpdateAssessmentReportResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.DeleteAssessmentReport
   */
  deleteAssessmentReport: {
    methodKind: "unary";
    input: typeof DeleteAssessmentReportRequestSchema;
    output: typeof DeleteAssessmentReportResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentReportService.ListAssessmentReports
   */
  listAssessmentReports: {
    methodKind: "unary";
    input: typeof ListAssessmentReportsRequestSchema;
    output: typeof ListAssessmentReportsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_assessment_report_service, 0);

